/* eslint-disable arrow-body-style */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { orderBy } from 'lodash';

import { withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
// import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
// import InputLabel from '@material-ui/core/InputLabel';
// import NativeSelect from '@material-ui/core/NativeSelect';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableHeaderEnhance from '../../widgets/table/TableHeaderEnhance';
import TablePaginationActionsWrapped from '../../widgets/table/TablePaginationActions';
import { FaSpinner } from '../../../utils/Fontawesome';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableRow from '@material-ui/core/TableRow';
import {
  styles, StyledTableRow,
} from './Style';
import GetAppIcon from '@material-ui/icons/GetApp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SaveIcon from '@material-ui/icons/Save';
import FileDownloadIcon from '@material-ui/icons/CloudDownload';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

// table Header
const columnData = [
  {
    id: 'level', disablePadding: false, label: 'ระดับ', sortable: false, align: 'left',
  },
  {
    id: 'eventDate', disablePadding: false, label: 'วันที่', sortable: true, align: 'left',
  },
  {
    id: 'provices', disablePadding: false, label: 'จังหวัด', sortable: true, align: 'left',
  },
  {
    id: 'amphon', disablePadding: false, label: 'อำเภอ', unit: '', sortable: true, align: 'left',
  },
  {
    id: 'tumbon', disablePadding: false, label: 'ตำบล', unit: '', sortable: true, align: 'left',
  },
  {
    id: 'ffpi', disablePadding: false, label: 'FFPI', unit: '', sortable: true, align: 'left',
  },
  {
    id: 'rfhistoric', disablePadding: false, label: 'ฝนสะสมย้อนหลัง 5 วัน', sortable: true, align: 'center',
  },
  {
    id: 'rainForecast', disablePadding: false, label: 'ฝนล่วงหน้า  1 วัน', sortable: true, align: 'center',
  },
  {
    id: 'telestation', disablePadding: false, label: 'สถานีติดตาม', sortable: true, align: 'left',
  },
  {
    id: 'basin', disablePadding: false, label: 'ลุ่มน้ำ', sortable: true, align: 'left',
  },
];

// const styles = theme => ({
//   root: {
//     display: 'flex',
//     flexWrap: 'wrap',
//   },
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 120,
//   },
//   selectEmpty: {
//     marginTop: theme.spacing(2),
//   },
//   button: {
//     margin: theme.spacing(1),
//   },
// });

const DownloadDocumentIcon = ({ size = 26, color = '#66788A' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31 32C28.24 32 26 34.24 26 37V88C26 90.76 28.24 93 31 93H53V87H33V38H52V56H70V62H76V54L56 32H31Z"
      fill={color}
    />
    <path
      d="M52 32V56H76L52 32Z"
      fill={color}
    />
    <path
      d="M69 64V82H61L72 93L83 82H75V64H69Z"
      fill={color}
    />
    <path
      d="M61 98H85V104H61V98Z"
      fill={color}
    />
  </svg>
);
class FlashFloodList extends Component {
  state = {
    isLoading: false,
    error: null,
    order: 'desc',
    orderByState: 'rainForecast',
    page: 0,
    rowsPerPage: 10,
    search: '',
    lastSearchDatas: [],
  };

  handleDownloadAll = () => {
    this.handleDownloadCSV();
    this.handleDownloadXLSX();
  };

  getExportData = () => {
    const { order, orderByState, lastSearchDatas } = this.state;
    return orderBy(lastSearchDatas, orderByState, order).map((d) => ({
      ระดับ: 'วิกฤต',
      วันที่: d.eventDate || '',
      จังหวัด: d.provices?.replace('จ.', '') || '',
      อำเภอ: d.amphon?.replace('อ.', '') || '',
      ตำบล: d.tumbon?.replace('ต.', '') || '',
      FFPI: d.ffpi || '',      
      'ฝนสะสมย้อนหลัง 5 วัน': d.rfhistoric || '',
      'ฝนล่วงหน้า 1 วัน': d.rainForecast || '',
      สถานีติดตาม: d.telestation || '',
      ลุ่มน้ำ: d.basin || '',
    }));
  };

  handleDownloadCSV = () => {
    const rows = this.getExportData();
    const headers = Object.keys(rows[0] || {});
    const today = dayjs().format('YYYYMMDD');
    const csvContent = [
      headers.join(','),
      ...rows.map((r) =>
        headers.map((h) => `"${(r[h] ?? '').toString().replace(/"/g, '""')}"`).join(',')
      ),
    ].join('\n');

    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `watchlist_daily_${today}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  handleDownloadXLSX = () => {
    const rows = this.getExportData();
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    const today = dayjs().format('YYYYMMDD');
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FlashFlood');
    XLSX.writeFile(workbook, `watchlist_daily_${today}.xlsx`);
  };

  
  componentDidMount() {
    const { datas } = this.props;
    const cleaned = (datas || []).filter(d => d.provices !== undefined);
    this.setState({ lastSearchDatas: cleaned });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  // for sort table
  handleRequestSort = (event, property) => {
    const { order, orderByState } = this.state;
    const orderByProperty = property;
    let orderLocal = 'desc';
    if (orderByState === property && order === 'desc') {
      orderLocal = 'asc';
    }
    this.setState({ order: orderLocal, orderByState: orderByProperty });
  };

  handleChangeSearch = (name) => (event) => {
    this.setState({ [name]: event.target.value }, this.filterDatas);
  };

  filterDatas() {
    const { search } = this.state;
    const { datas } = this.props;

    const filtered = (datas || [])
      .filter(d => d.provices !== undefined)  // ← เพิ่มตรงนี้
      .filter((d) => {
        if (!search) return true;
        return ['provices', 'amphon', 'tumbon', 'basin', 'telestation'].some((field) =>
          (d[field] || '').toString().toLowerCase().includes(search.toLowerCase())
        );
      });

    this.setState({ lastSearchDatas: filtered });
  }

  render() {
    const {
      isLoading,
      error,
      order,
      orderByState,
      rowsPerPage,
      page,
      search,
      lastSearchDatas,
    } = this.state;
    const { classes, t, onRowClick } = this.props;
    if (error) {
      return (
        <div className="text-center">
          {error.message}
        </div>
      );
    }
    if (isLoading) {
      return (
        <div className="text-center">
          <FaSpinner size={30} />
        </div>
      );
    }

    const paginatedData = orderBy(lastSearchDatas, orderByState, order)
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Paper
              elevation={0}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '340px',
                height: 40,
                padding: '0 11px',
                border: '1px solid #D9D9D9',
                borderRadius: 9,
                marginTop: -8,
                marginBottom: 8,
              }}
            >
              <IconButton
                style={{
                  padding: 0,
                  marginRight: 8,
                }}
              >
                <SearchIcon style={{ fontSize: 14, transform: 'scaleX(-1)',}} />
              </IconButton>

              <InputBase
                style={{
                  flex: 1,
                }}
                value={search}
                onChange={this.handleChangeSearch('search')}
                placeholder={t('ค้นหาในตาราง')}
              />
            </Paper>                
            <IconButton
              style={{
                padding: 4,
                marginLeft: 'auto',
                marginTop: -8,
              }}
              onClick={this.handleDownloadAll}
              title={t('ดาวน์โหลด')}
            >


              <span
                style={{
                  fontFamily: 'Kanit',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: 14,
                  lineHeight: '100%',
                  letterSpacing: 0,
                  color: '#526879',
                }}
              >
                ดาวน์โหลด
              </span>              
              <DownloadDocumentIcon/>
            </IconButton>
            </div>
          </Grid>
        </Grid>
        <TableContainer style={{ margin: 0, padding: 0 }}>
          <Table className={classes.table} style={{ color: '#12263B', fontFamily: 'Kanit' }}>
            <TableHead>
              <TableRow>
                {columnData.map((col) => (
                  <TableCell
                    key={col.id}
                    align={col.align}
                    sortDirection={orderByState === col.id ? order : false}
                    style={{
                      backgroundColor: '#F0F5F8',
                      color: '#526879',
                      fontFamily: 'Kanit',
                      borderBottom: '2px solid #EEF3F6',
                    }}
                  >
                    {col.sortable ? (
                      <TableSortLabel
                        active={orderByState === col.id}
                        direction={orderByState === col.id ? order : 'asc'}
                        onClick={(e) => this.handleRequestSort(e, col.id)}
                        style={{ color: '#526879', fontFamily: 'Kanit' }}
                      >
                        {col.label}
                      </TableSortLabel>
                    ) : col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody style={{ fontFamily: 'Kanit', color: '#12263B' }}>
              {paginatedData.map((data, index) => (
                <StyledTableRow key={`${data.geocode || 'geo'}-${index}`} hover onClick={() => onRowClick && onRowClick(data)} style={{ cursor: onRowClick ? 'pointer' : 'default' }}>
                  <TableCell align="left">
                    <span style={{ color: 'red', marginRight: 4 }}>●</span>วิกฤต
                  </TableCell>
                  <TableCell align="left">{data.eventDate}</TableCell>
                  <TableCell align="left">{data.provices?.replace('จ.', '') }</TableCell>
                  <TableCell align="left">{data.amphon?.replace('อ.', '') }</TableCell>
                  <TableCell align="left">{data.tumbon?.replace('ต.', '') }</TableCell>
                  <TableCell style={{fontWeight: 700}} align="left">{data.ffpi }</TableCell>
                  <TableCell align="center">{data.rfhistoric }</TableCell>
                  <TableCell align="center">{data.rainForecast }</TableCell>
                  <TableCell align="left">{data.telestation }</TableCell>
                  <TableCell align="left">{data.basin }</TableCell>
                </StyledTableRow>
              ))}
              {paginatedData.length === 0 && (
                <StyledTableRow>
                  <TableCell colSpan={10} align="center">{t('ไม่มีข้อมูล')}</TableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          className={classes.hiddenLine}
          // count={lastSearchDatas.length}
          count={lastSearchDatas.filter(d => d.provices).length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActionsWrapped}
          labelRowsPerPage={t('จำนวนแถวต่อหน้า')}
          labelDisplayedRows={({ from, to, count }) => `${t('แสดงรายการ')} ${from}-${to} ${t('จาก')} ${count} ${t('รายการ')}`}
          style={{ fontFamily: 'Kanit' }}
        />
      </>
    );
  }
}

FlashFloodList.propTypes = {
  classes: PropTypes.object.isRequired,
  datas: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
};

export default withTranslation()(withStyles(styles)(FlashFloodList));
